<template>
  <div class="container">
    <div class="left-container">
      <div class="logo-container">
        <img src="../../../assets/logo.png" id="logo" style="max-width: 160px; height: auto">
      </div>
      <div class="form-container">
        <form v-on:submit.prevent="submit()" class="form">
          <div class="title">Login to your account</div>
          <label class="label-login">E-mail</label>
          <div class="input-wrapper">
            <img src="../../../assets/mail.svg" class="input-icon">
            <input v-model="form.username" name="email" class="input input__round" type="email">
          </div>
          <label class="label-login">Password</label>
          <div class="input-wrapper">
            <img src="../../../assets/key.svg" class="input-icon">
            <input v-model="form.password" name="password" class="input input__round" type="password">
            <img src="../../../assets/eye.svg" class="input-icon-eye">
          </div>
          <button class="submit" type="submit">Login</button>
          <div class="remember-me forgot-pass">
            <label id="rememberMe"><input type="checkbox"> Remember Me</label>
            <router-link to="/auth/forgot-password" class="forgot-pass">Forgot password</router-link>
          </div>
        </form>
      </div>
    </div>
    <RightPanel/>
  </div>
</template>

<script>
import RightPanel from "../shared-comp/RightPanel";
import { mapActions } from "vuex";
import router from '../../../routes'

export default {
  name: "Login",
  beforeMount() {

    //Check if Logged in
    let auth = this.$store.getters;

    if(auth.isAuthenticated){

      auth.getAuth.user.roles.forEach((role) => {
        //Redirect
        if(role.name == 'client-user'){
            router.push('/dashboard/customers');
            return false;
        }
        if(role.name == 'super-admin'){
            router.push('/dashboard/clients');
            return false;
        }
      });

    }
  },
  created() {
    document.title = 'PayGate Invoice'
  },
  data: function() {
    return {
      form: {
        username: this.$route.query.email || "",
        password: ""
      }
    };
  },
  methods: {
    ...mapActions(["login"]),
    submit() {
      this.login({data: this.form, success: this.$toasted.success, error: this.$toasted.error});
    }
  },
  components: {
    RightPanel
  }
};
</script>

<style lang="scss" scoped>
.forgot-pass {
  text-decoration: none;
  float: right;
  color: inherit;
  font-size: 12px;
}
.remember-me {
  margin-top: 15px;
  font-family: Montserrat-Regular;
}
.submit {
  margin-top: 20px;
  cursor: pointer;
  border-radius: 18px;
  font-family: Montserrat-SemiBold;
  border: none;
  background: #5A78FF;
  color: white;
  padding: 10px 20px;
  outline: none;
  transition: box-shadow .18s ease-in;
}
.submit:hover,
.submit:focus,
.submit:visited,
.submit:active {
  box-shadow: 0 0px 8px rgba(90, 120, 255, 0.75);
}
.input-icon {
  position: absolute;
  left: 10px;
  top: 11px;
}
.input-icon-eye {
  right: 10px;
  cursor: pointer;
  top: 13px;
  &:hover {
    opacity: 0.6;
  }
  position: absolute;
}
.input-wrapper {
  position: relative;
}
.title {
  font-family: Montserrat-SemiBold;
  font-size: 22px;
  margin-bottom: 20px;
}
.label-login {
  margin: 10px 0px;
  background: transparent;
  font-family: Montserrat-Regular;
}
.input {
  width: 100%;
  padding-left: 40px;
}
.form-container {
  display: flex;
  height: 60%;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}
.form {
  width: fit-content;
  display: flex;
  flex-direction: column;
}
.container {
  width: 100%;
  display: flex;
  height: 100vh;
}
.left-container {
  width: 50%;
  height: 100%;
}
#logo {
  margin-top: 40px;
  margin-left: 50px;
}
.logo-container {
  width: 100%;
}
#rememberMe {
  display: inline-block;
  padding-left: 15px;
  text-indent: -15px;
  font-size: 12px;
  cursor: pointer;
}
#rememberMe input {
  width: 13px;
  height: 13px;
  padding: 0;
  margin:0;
  vertical-align: bottom;
  position: relative;
  top: -1px;
  *overflow: hidden;
}
</style>
